import api from 'networkapp-api-connector';

export default {
    /**
     * Invites users to a new meeting
     * @param  {int} eventId
     * @param  {int} locationId
     * @param  {string} startTimestamp          Start timestamp, ISO8601
     * @param  {string} meetingName             Question text or "Meeting"
     * @param  {array} invitedUsers             List of user ids (int)
     * @param  {array} invitedSpeakers          List of speaker ids (int)
     * @param  {string} details                 Note with the reason for the meeting, if needed
     * @param  {int} other.questionId           Optional. Question that started meetingName
     * @param  {int} other.rescheduleMeetingId  Optional. Id of the meeting to reschedule
     * @return {Promise}                        Promise with answer from API
     */
    invite: function (eventId, locationId, startTimestamp, meetingName, invitedUsers, invitedSpeakers, details, other = {}) {
        const {questionId, rescheduleMeetingId} = other;
        return api.meetings
            .invite(eventId, locationId, startTimestamp, meetingName, invitedUsers, invitedSpeakers, details, {questionId, rescheduleMeetingId})
            .then(meeting => {
                app.store.dispatch(app.actions.meetings.meetingCreated(eventId, meeting));
                if (rescheduleMeetingId) {
                    app.store.dispatch(
                        app.actions.meetings.meetingUpdate(eventId, {
                            id: rescheduleMeetingId,
                            cancelled: true,
                        })
                    );
                }
                return meeting;
            })
            .catch(err => {
                console.error(err);
                throw err;
            });
    },
    block: function (eventId, startTimestamp, endTimestamp) {
        return api.meetings.block(eventId, startTimestamp, endTimestamp).then(meeting => {
            app.store.dispatch(app.actions.meetings.meetingCreated(eventId, meeting));
            return meeting;
        });
    },
    unblock: function (eventId, meetingId) {
        return api.meetings.unblock(eventId, meetingId).then(response => {
            if (response?.success) {
                app.store.dispatch(app.actions.meetings.slotBlock(eventId, meetingId, false));
            }
            return response;
        });
    },
    accept: function (meetingId) {
        var userId = app.store.getState().session.user.id;
        return api.meetings.accept(userId, meetingId).then(response => {
            app.store.dispatch(app.actions.meetings.meetingUpdate(response.meeting.event_id, response.meeting));
        });
    },
    reject: function (meetingId, reason, reasonText) {
        var userId = app.store.getState().session.user.id;
        return api.meetings.reject(userId, meetingId, reason, reasonText).then(response => {
            app.store.dispatch(app.actions.meetings.meetingUpdate(response.meeting.event_id, response.meeting));
        });
    },
    checkAvailability: function (eventId, users, speakers) {
        return api.meetings.checkAvailability(eventId, users, speakers).then(response => {
            // fix received timestamps - server doesn't include timezone value and it's interpreted as local
            // response.result = response.result.map(slot => ({
            //     ...slot,
            //     start_utc: moment.utc(slot.start_utc).toISOString(),
            //     end_utc: moment.utc(slot.end_utc).toISOString(),
            // }));

            if (!users && !speakers) {
                // When no criteria is specified, only the current user availability is used
                app.store.dispatch(app.actions.availability.update(eventId, response.result));
            }
            return response.result;
        });
    },
    REJECTION_REASONS: api.meetings.REJECTION_REASONS,
};
